/**
 * Features MVI Intents
 *
 * Discriminated union of all feature actions.
 */

import type { IFeature } from "@/shared/types";
import type { IApiError } from "@/shared/types";

// ============================================================================
// Intent Type
// ============================================================================

export type TFeaturesIntent =
  | { type: "LOAD_FEATURES_START" }
  | {
      type: "LOAD_FEATURES_SUCCESS";
      /** Проект, чей перечень пришёл: выбор фичи принадлежит ему (R10). */
      projectId: string;
      features: readonly IFeature[];
    }
  | { type: "LOAD_FEATURES_ERROR"; error: IApiError }
  | { type: "SELECT_FEATURE"; featureId: string }
  | { type: "CREATE_FEATURE_START" }
  | { type: "CREATE_FEATURE_SUCCESS"; feature: IFeature }
  | { type: "CREATE_FEATURE_ERROR"; error: IApiError }
  | { type: "LOAD_WITH_ARCHIVED_SUCCESS"; features: readonly IFeature[] }
  | { type: "UPDATE_FEATURE_START" }
  | { type: "UPDATE_FEATURE_SUCCESS"; feature: IFeature }
  | { type: "UPDATE_FEATURE_ERROR"; error: IApiError }
  | { type: "DELETE_FEATURE_START" }
  | { type: "DELETE_FEATURE_SUCCESS"; featureId: string }
  | { type: "DELETE_FEATURE_ERROR"; error: IApiError }
  | { type: "CLEAR_FEATURES" };

// ============================================================================
// Intent Creators
// ============================================================================

export const intents = {
  loadFeaturesStart: (): TFeaturesIntent => ({
    type: "LOAD_FEATURES_START",
  }),

  loadFeaturesSuccess: (
    projectId: string,
    features: readonly IFeature[],
  ): TFeaturesIntent => ({
    type: "LOAD_FEATURES_SUCCESS",
    projectId,
    features,
  }),

  loadFeaturesError: (error: IApiError): TFeaturesIntent => ({
    type: "LOAD_FEATURES_ERROR",
    error,
  }),

  selectFeature: (featureId: string): TFeaturesIntent => ({
    type: "SELECT_FEATURE",
    featureId,
  }),

  createFeatureStart: (): TFeaturesIntent => ({
    type: "CREATE_FEATURE_START",
  }),

  createFeatureSuccess: (feature: IFeature): TFeaturesIntent => ({
    type: "CREATE_FEATURE_SUCCESS",
    feature,
  }),

  createFeatureError: (error: IApiError): TFeaturesIntent => ({
    type: "CREATE_FEATURE_ERROR",
    error,
  }),

  /** Перечень с архивными для поверхности управления фичами (R28). */
  loadWithArchivedSuccess: (features: readonly IFeature[]): TFeaturesIntent => ({
    type: "LOAD_WITH_ARCHIVED_SUCCESS",
    features,
  }),

  updateFeatureStart: (): TFeaturesIntent => ({
    type: "UPDATE_FEATURE_START",
  }),

  updateFeatureSuccess: (feature: IFeature): TFeaturesIntent => ({
    type: "UPDATE_FEATURE_SUCCESS",
    feature,
  }),

  updateFeatureError: (error: IApiError): TFeaturesIntent => ({
    type: "UPDATE_FEATURE_ERROR",
    error,
  }),

  deleteFeatureStart: (): TFeaturesIntent => ({
    type: "DELETE_FEATURE_START",
  }),

  deleteFeatureSuccess: (featureId: string): TFeaturesIntent => ({
    type: "DELETE_FEATURE_SUCCESS",
    featureId,
  }),

  deleteFeatureError: (error: IApiError): TFeaturesIntent => ({
    type: "DELETE_FEATURE_ERROR",
    error,
  }),

  clearFeatures: (): TFeaturesIntent => ({
    type: "CLEAR_FEATURES",
  }),
};
